import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const FooterSection = () => {
    const footerRef = useRef(null);
    const titleRef = useRef(null);
    const contactBtnRef = useRef(null);
    const navigate = useNavigate();


    const [menuActive, setMenuActive] = useState(false);

    const toggleMenu = () => {
        setMenuActive(!menuActive);
    };

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from(titleRef.current, {
                opacity: 0,
                y: 80,
                duration: 1.5,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: footerRef.current,
                    start: "top 80%",
                },
            });

            gsap.from(contactBtnRef.current, {
                scale: 0,
                duration: 1.2,
                ease: "back.out(1.7)",
                scrollTrigger: {
                    trigger: footerRef.current,
                    start: "top 75%",
                },
            });
        }, footerRef);

        return () => ctx.revert();
    }, []);

    return (
        <footer
            ref={footerRef}
            className="relative bg-[#0e0e0e] text-white md:pt-24 pt-12 pb-10 px-6 md:px-16 overflow-hidden "
        >
            {/* Glowing Gradient Background */}
            <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-gradient-to-br from-orange-600 to-red-700 blur-[200px] opacity-60"></div>

            <div className="max-w-screen-2xl mx-auto ">
                {/* Main Top Section */}
                <div className=" grid lg:grid-cols-2 items-center ">
                    {/* Email Input */}
                    <div className="md:mb-0 mb-6">
                        <a href="/" className="flex items-center relative z-10 md:justify-start justify-center">
                            <img className="w-56 mr-2"
                                src={require("../assets/viskohr-logo.webp")}

                                // src="https://viskohr.com/static/media/Visko_logo.096d8e010f7b30432a17.png" 
                                alt="" />
                        </a>
                        <p className="text-xs max-w-sm pt-2 text-[#949CAA] text-center md:text-start">We’re here to support your hiring growth in Dubai and across the UAE. Reach out for a free consultation or follow us for updates on AI hiring trends, recruitment insights, and career resources.</p>
                    </div>



                    {/* Social Icons */}
                    <div className=" flex md:justify-end justify-center gap-5">
                        {[
                            {
                                icon: "mdi:facebook",
                                link: "https://www.facebook.com/remarkhr",
                            },
                            {
                                icon: "mdi:instagram",
                                link: "https://www.instagram.com/remarkhr",
                            },
                            {
                                icon: "mdi:twitter",
                                link: "https://twitter.com/Remark_official",
                            },
                            {
                                icon: "mdi:linkedin",
                                link: "https://www.linkedin.com/company/remark-official",
                            },
                        ].map((item, i) => (
                            <a
                                key={i}
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-12 h-8 md:h-12 flex items-center justify-center rounded-full bg-[#1a1a1a] hover:bg-orange-500 hover:text-white border border-gray-500 text-gray-300 transition-all duration-300 cursor-pointer"
                            >
                                <Icon icon={item.icon} className="w-5 h-5" />
                            </a>
                        ))}
                    </div>
                </div>

                {/* Bottom Nav Links */}
                <div className="mt-16 border-t border-gray-800 pt-8 z-20 relative">
                    <div className="grid grid-cols-2 md:grid-cols-6 gap-4 text-center text-gray-400 text-sm">
                        <a href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                document.querySelector("#about")?.scrollIntoView({ behavior: "smooth" });
                                setMenuActive(false);
                            }} className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline">HOME</a>
                        <a href="#about"
                            onClick={(e) => {
                                e.preventDefault();
                                document.querySelector("#about")?.scrollIntoView({ behavior: "smooth" });
                                setMenuActive(false);
                            }} className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline">ABOUT</a>
                        <a href="#services"
                            onClick={(e) => {
                                e.preventDefault();
                                document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" });
                                setMenuActive(false);
                            }} className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline">SERVICES</a>
                        <a href="#features"
                            onClick={(e) => {
                                e.preventDefault();
                                document.querySelector("#features")?.scrollIntoView({ behavior: "smooth" });
                                setMenuActive(false);
                            }} className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline">FEATURES</a>

                        <a href="#ourproducts"
                            onClick={(e) => {
                                e.preventDefault();
                                document.querySelector("#ourproducts")?.scrollIntoView({ behavior: "smooth" });
                                setMenuActive(false);
                            }} className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline">OUR PRODUCTS</a>
                        <a href="#contact"
                            onClick={(e) => {
                                e.preventDefault();
                                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
                                setMenuActive(false);
                            }} className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline">CONTACT US</a>
                    </div>
                </div>


                <div className="mt-16 border-t border-gray-800 pt-8 z-20 relative">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center text-gray-400 text-sm">

                        <button
                            onClick={() => {
                                navigate("/policies/terms-conditions");
                                setMenuActive(false);
                            }}
                            className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline"
                        >
                            TERMS & CONDITIONS
                        </button>

                        <button
                            onClick={() => {
                                navigate("/policies/cookies");
                                setMenuActive(false);
                            }}
                            className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline"
                        >
                            COOKIES POLICY
                        </button>

                        <button
                            onClick={() => {
                                navigate("/policies/privacy-policy");
                                setMenuActive(false);
                            }}
                            className="hover:text-white cursor-pointer hover:scale-105 transition-transform hover:underline"
                        >
                            PRIVACY POLICY
                        </button>
                    </div>
                </div>

                {/* Copyright */}
                <p className="lg:mt-8 pt-12 text-center text-gray-500 text-lg">
                    All Rights Reserved | Visko HR LLC © 2026
                </p>
            </div>

        </footer>
    );
};

export default FooterSection;
